/* eslint-disable camelcase */

import React from 'react';
import SelectedProductsTable from './SelectedProductsTable';

interface I_SelectedProductsItem {
  index?: number;
  category_id: number;
  category_name: string;
  description?: string;
  item_id: number;
  item_price_before_tax: string;
  price_before_tax: string;
  product_id: number;
  product_name: string;
  quantity: string;
  tax_amount: string;
  tax_rate: string;
  unit_quantity: string;
  unit_type?: any; // Find out this type later please
}

interface I_SelectedProductsContext {
  // handleAddItems: (newItems: Array<I_SelectedProductsItem>) => void;
  // initialItems?: Array<I_SelectedProductsItem>;
  feedback: boolean;
  items: Array<I_SelectedProductsItem>;
  // addItemHandler: (newItem: I_SelectedProductsItem) => void;
  setCurrentItems: () => void;
  setItemToChange: () => void;
}

function SelectedProducts({
  items,
  feedback,
  setCurrentItems,
  setItemToChange,
}: I_SelectedProductsContext) {
  return (
    <div>
      <SelectedProductsTable
        feedback={feedback}
        items={items}
        setItemToChange={setItemToChange}
        setCurrentItems={setCurrentItems}
      />
    </div>
  );
}

export default SelectedProducts;
